import React from 'react';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import isNotEmptyReactElementContent from 'core/utils/content';

/**
 * @author Dmitry Grigorov <d.grigorov@rambler-co.ru>
 */
function Lead({ children, theme }) {
  if (isNotEmptyReactElementContent(children)) {
    return (
      <div className='lead'>
        <style jsx>{`
          .lead
            font ${theme.texts.lead.font}
            color ${theme.texts.lead.color}
        `}</style>
        {children}
      </div>
    );
  }
  return null;
}

Lead.propTypes = {
  /** Контент лида */
  children: PropTypes.node,
  /** @ignore */
  theme: themePropTypes(`
    {
      texts: {
        lead: {
          font,
          color,
        }
      }
    }
  `),
};

const LeadWithHOCs = withTheme(Lead);
LeadWithHOCs.displayName = 'Lead';

export { Lead as StorybookComponent };
export default LeadWithHOCs;
